import { request } from "../request";

export const uploadPicture = (data) => {
    return request({
        method: 'post',
        url: '/file/upload',
        params: data
    })
}